export default __webpack_public_path__ + "d93e2a08ffc6bbfe4683e3f7d0fffe32.svg";